import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { EntityApi, ProductType } from '@inter-ikea-storageone/range';
export class LadmakareEntityApi extends EntityApi {
    /**
     * @override Custom duplicate to make sure LADMAKARE systems that handle right/middle/left panels are triggered properly
     */
    duplicate() {
        const selectedEntity = this.findSelectedEntity();
        if (!selectedEntity)
            throw new Error('Found no entity that is selected');
        const copyEntity = HierarchyUtils.duplicateEntity(selectedEntity, this.core.services);
        const placementResult = this.placementService.snapToScene(copyEntity);
        if (!placementResult.valid) {
            // If the placement should fail, this will remove the copyEntity from the entityManager
            this.core.services.entityManager.disposeEntity(copyEntity);
        }
        return placementResult;
    }
    /**
     * @override handle sections where side units has been removed/merged
     */
    getObjectIdsByEntity(entity) {
        const includedObjectIds = super.getObjectIdsByEntity(entity);
        if (entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
            const adjustedPanels = [...includedObjectIds];
            const panels = this.getChildrenWithProductType(entity, ProductType.LADMAKARE_PANEL);
            // If only one panel, we must find the left adjacent entity which has the shared middle panel on it's right panel
            if (panels.length === 1) {
                const partKey = panels?.[0].getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)?.partKey;
                const { left: leftEntity } = super.getAlignedFrames(entity, 'align-left', 'align-right', true, true);
                if (partKey === 'right-panel' && leftEntity) {
                    const missingPanel = this.getChildrenWithProductType(leftEntity, ProductType.LADMAKARE_PANEL)?.find(panel => panel.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)
                        ?.partKey === 'right-panel');
                    missingPanel && adjustedPanels.push(...super.getObjectIdsByEntity(missingPanel));
                }
            }
            return adjustedPanels;
        }
        return includedObjectIds;
    }
}
//# sourceMappingURL=LadmakareEntityApi.js.map